module.exports = __webpack_public_path__ + "media/images/icons/material/forward-a49040aee3ebb8c24d3102a014289aa1.svg";